/**
 * Balance top-ups. `usePaymentMethods` tells the Add Funds modal which
 * providers are configured (stripe/paypal/crypto) and the allowed
 * amount range; checkout creation is a plain api.post in the modal
 * because it ends in a full-page redirect (no cache to manage).
 */

import { useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api';

export interface PaymentMethods {
  stripe: boolean;
  paypal: boolean;
  crypto: boolean;
  min_usd: number;
  max_usd: number;
}

export function usePaymentMethods(enabled: boolean) {
  return useQuery({
    queryKey: ['payments', 'methods'],
    queryFn: () => api.get<PaymentMethods>('/v1/payments/methods'),
    enabled,
    staleTime: 5 * 60_000,
  });
}
